var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgWhiteTop = function SvgWhiteTop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 805 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#white-top_svg__a)",
    stroke: "#fff",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.514.484H.534v68.032h67.98V.484Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.495 0c0 19.018-15.198 34.437-33.99 34.437S.593 19.057.593 0M68.864 34.476H0M14.024 56.995c2.976 0 5.39-2.403 5.39-5.368 0-2.965-2.414-5.37-5.39-5.37-2.977 0-5.39 2.405-5.39 5.37 0 2.965 2.413 5.368 5.39 5.368ZM34.437 56.995c2.977 0 5.39-2.403 5.39-5.368 0-2.965-2.413-5.37-5.39-5.37s-5.39 2.405-5.39 5.37c0 2.965 2.413 5.368 5.39 5.368ZM54.841 56.995c2.977 0 5.39-2.403 5.39-5.368 0-2.965-2.413-5.37-5.39-5.37s-5.39 2.405-5.39 5.37c0 2.965 2.413 5.368 5.39 5.368Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#white-top_svg__b)",
    stroke: "#fff",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.47.541v67.976h66.05V.54H68.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.47 34.524c4.343.005 8.642.889 12.652 2.6a33.023 33.023 0 0 1 10.72 7.373 34.022 34.022 0 0 1 7.154 11.024 34.739 34.739 0 0 1 2.499 12.996M101.505.541a34.733 34.733 0 0 1-2.504 12.995 34.02 34.02 0 0 1-7.157 11.022 33.022 33.022 0 0 1-10.72 7.37 32.318 32.318 0 0 1-12.653 2.596"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.473 68.517V.483H68.471v68.034h66.002Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.473 34.495a32.319 32.319 0 0 1-12.647-2.61 33.025 33.025 0 0 1-10.712-7.38 34.032 34.032 0 0 1-7.146-11.027A34.737 34.737 0 0 1 101.477.483M101.467 68.517a34.737 34.737 0 0 1 2.492-13 34.032 34.032 0 0 1 7.148-11.03 33.035 33.035 0 0 1 10.715-7.381 32.329 32.329 0 0 1 12.651-2.61"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#white-top_svg__c)",
    stroke: "#fff",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M201.521.484h-67.042v68.032h67.042V.484Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.521 32.213c0 19.873-15.007 35.984-33.54 35.984s-33.502-16.11-33.502-35.984M201.435 34.514h-66.898M134.422.339l33.607 33.963M201.617.339 168.02 34.292M171.684 20.636c1.956-2.176 1.795-5.54-.361-7.514a5.237 5.237 0 0 0-7.445.364c-1.956 2.175-1.795 5.539.361 7.513a5.237 5.237 0 0 0 7.445-.363Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#white-top_svg__d)",
    stroke: "#fff",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M671.514.484h-67.98v68.032h67.98V.484Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M671.495 0c0 19.018-15.198 34.437-33.99 34.437-18.791 0-33.912-15.38-33.912-34.437M671.864 34.476H603M617.024 56.995c2.976 0 5.39-2.403 5.39-5.368 0-2.965-2.414-5.37-5.39-5.37-2.977 0-5.39 2.405-5.39 5.37 0 2.965 2.413 5.368 5.39 5.368ZM637.437 56.995c2.976 0 5.39-2.403 5.39-5.368 0-2.965-2.414-5.37-5.39-5.37-2.977 0-5.39 2.405-5.39 5.37 0 2.965 2.413 5.368 5.39 5.368ZM657.841 56.995c2.977 0 5.39-2.403 5.39-5.368 0-2.965-2.413-5.37-5.39-5.37s-5.39 2.405-5.39 5.37c0 2.965 2.413 5.368 5.39 5.368Z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#white-top_svg__e)",
    stroke: "#fff",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M671.471.541v67.976h66.049V.54h-66.049Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M671.471 34.524c4.342.005 8.641.889 12.651 2.6a33.028 33.028 0 0 1 10.72 7.373 34.043 34.043 0 0 1 7.154 11.024 34.745 34.745 0 0 1 2.499 12.996M704.505.541a34.742 34.742 0 0 1-2.503 12.995 34.024 34.024 0 0 1-7.158 11.022 33.01 33.01 0 0 1-10.721 7.37 32.317 32.317 0 0 1-12.652 2.596"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M737.473 68.517V.483h-66.002v68.034h66.002Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M737.473 34.495a32.319 32.319 0 0 1-12.647-2.61 33.025 33.025 0 0 1-10.712-7.38 34.032 34.032 0 0 1-7.146-11.027A34.737 34.737 0 0 1 704.477.483M704.467 68.517a34.737 34.737 0 0 1 2.492-13 34.032 34.032 0 0 1 7.148-11.03 33.035 33.035 0 0 1 10.715-7.381 32.329 32.329 0 0 1 12.651-2.61"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#white-top_svg__f)",
    stroke: "#fff",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M804.521.484h-67.042v68.032h67.042V.484Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M804.521 32.213c0 19.873-15.007 35.984-33.54 35.984s-33.502-16.11-33.502-35.984M804.435 34.514h-66.898M737.422.339l33.607 33.963M804.617.339 771.02 34.292M774.684 20.636c1.956-2.176 1.795-5.54-.361-7.514a5.237 5.237 0 0 0-7.445.364c-1.956 2.175-1.795 5.539.361 7.513a5.237 5.237 0 0 0 7.445-.363Z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#white-top_svg__g)",
    stroke: "#fff",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M335.454 34.485H319.36M284.698 34.485h-15.86M283.519 36.92a21.642 21.642 0 0 0-2.571 9.918 21.675 21.675 0 0 0 2.268 9.996 21.21 21.21 0 0 0 6.584 7.757c2.781 2.001 6 3.279 9.375 3.723.717.104 1.439.167 2.163.19h-32.851V.496h33.611l-17.332 33.978-1.247 2.444ZM335.513.497v67.996H302.78a18.705 18.705 0 0 0 2.133-.179 20.712 20.712 0 0 0 9.446-3.809 21.245 21.245 0 0 0 6.575-7.895 21.698 21.698 0 0 0 2.158-10.122 21.662 21.662 0 0 0-2.767-9.966l-.049-.11-.974-1.937L302.098.497h33.415Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.345 68.245h-3.196v.507h3.196v-.507Z",
    fill: "#fff",
    strokeWidth: 0.5
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#white-top_svg__h)",
    stroke: "#fff",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M335.77 23.354c2.809 0 2.809 5.905 5.608 5.905 2.8 0 2.81-5.905 5.619-5.905 2.809 0 2.799 5.905 5.599 5.905 2.799 0 2.809-5.905 5.618-5.905 2.81 0 2.8 5.905 5.609 5.905s2.809-5.905 5.609-5.905c2.799 0 2.809 5.905 5.618 5.905 2.81 0 2.8-5.905 5.609-5.905s2.809 5.905 5.609 5.905c2.799 0 2.809-5.905 5.618-5.905 2.81 0 2.81 5.905 5.619 5.905 2.809 0 2.809-5.905 5.618-5.905M335.77 13.975c2.809 0 2.809 5.905 5.608 5.905 2.8 0 2.81-5.905 5.619-5.905 2.809 0 2.799 5.905 5.599 5.905 2.799 0 2.809-5.905 5.618-5.905 2.81 0 2.8 5.905 5.609 5.905s2.809-5.905 5.609-5.905c2.799 0 2.809 5.905 5.618 5.905 2.81 0 2.8-5.905 5.609-5.905s2.809 5.905 5.609 5.905c2.799 0 2.809-5.905 5.618-5.905 2.81 0 2.81 5.905 5.619 5.905 2.809 0 2.809-5.905 5.618-5.905M335.77 5.57c2.799 0 2.799 5.905 5.608 5.905 2.81 0 2.81-5.905 5.609-5.905s2.809 5.905 5.609 5.905c2.799 0 2.809-5.905 5.608-5.905 2.8 0 2.81 5.905 5.609 5.905 2.8 0 2.809-5.905 5.619-5.905 2.809 0 2.799 5.905 5.608 5.905 2.81 0 2.81-5.905 5.619-5.905 2.809 0 2.799 5.905 5.609 5.905 2.809 0 2.809-5.905 5.618-5.905 2.81 0 2.81 5.905 5.619 5.905 2.809 0 2.809-5.905 5.618-5.905"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.507.492h-68.014v68.016h68.014V.492Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.498 34.544c0 18.286-15.21 33.108-33.978 33.108s-33.967-14.822-33.967-33.108M335.661 34.505h67.63"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#white-top_svg__i)",
    stroke: "#fff",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M469.521.493h-66.042v68.014h66.042V.493Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.311 34.5a34.536 34.536 0 0 1-2.554 12.881 33.745 33.745 0 0 1-7.147 10.894 32.645 32.645 0 0 1-10.652 7.245 31.882 31.882 0 0 1-12.534 2.494 31.883 31.883 0 0 1-12.535-2.494 32.645 32.645 0 0 1-10.652-7.245 33.745 33.745 0 0 1-7.147-10.894 34.536 34.536 0 0 1-2.554-12.881M403.536 34.46h65.775"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.546 34.5a34.53 34.53 0 0 1 2.55-12.88 33.726 33.726 0 0 1 7.145-10.894 32.63 32.63 0 0 1 10.65-7.246A31.872 31.872 0 0 1 436.424.986a31.878 31.878 0 0 1 12.534 2.494 32.647 32.647 0 0 1 10.652 7.245 33.765 33.765 0 0 1 7.148 10.894 34.555 34.555 0 0 1 2.553 12.88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.298 34.5c0-7.409 2.858-14.514 7.945-19.753 5.087-5.239 11.986-8.182 19.18-8.182 7.194 0 14.094 2.943 19.181 8.182 5.087 5.239 7.945 12.344 7.945 19.753"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.06 34.5c0-5.835 2.25-11.431 6.257-15.557 4.006-4.126 9.44-6.444 15.106-6.444s11.1 2.318 15.106 6.444c4.007 4.126 6.257 9.722 6.257 15.557"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.822 34.5c.101-4.194 1.79-8.18 4.705-11.11 2.916-2.93 6.828-4.569 10.901-4.569 4.074 0 7.986 1.64 10.902 4.569 2.915 2.93 4.604 6.916 4.705 11.11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.584 34.5a10.288 10.288 0 0 1 2.989-6.967 9.702 9.702 0 0 1 6.855-2.86 9.7 9.7 0 0 1 6.855 2.86 10.279 10.279 0 0 1 2.989 6.967"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#white-top_svg__j)",
    stroke: "#fff",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M536.514.493h-67.029v68.014h67.029V.493Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.514.463c0 9.02-3.531 17.67-9.816 24.047-6.285 6.377-14.81 9.96-23.698 9.96-8.889 0-17.413-3.582-23.699-9.96-6.285-6.378-9.816-15.027-9.816-24.047"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.475 34.421c0 9.009-3.527 17.649-9.804 24.019-6.278 6.37-14.793 9.949-23.671 9.949s-17.393-3.579-23.671-9.95c-6.278-6.37-9.805-15.01-9.805-24.018M536.679 34.5h-67.135"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#white-top_svg__k)",
    stroke: "#fff",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M201.485.5v67.98h67.029V.5h-67.029Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.185.706c19.925 0 36.063 15.172 36.063 33.902S221.11 68.51 201.185 68.51M201.806 34.48h35.82M238.199 68.05V.99M244.618.99v67.06M251.026.99v67.05M257.445.99v67.05M263.854.99v67.05"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#white-top_svg__l)",
    stroke: "#fff",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M603.514.493h-67.028v68.014h67.028V.493Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.594 34.589c0-8.983 3.52-17.598 9.787-23.95C552.648 4.288 561.148.72 570.01.72c8.863 0 17.362 3.569 23.629 9.92 6.267 6.352 9.788 14.967 9.788 23.95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M603.427 34.5c-.15 8.89-3.739 17.363-9.994 23.596-6.255 6.232-14.676 9.725-23.447 9.725-8.772 0-17.192-3.493-23.447-9.725-6.256-6.233-9.845-14.707-9.994-23.596M536.594 34.5h66.726"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "white-top_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h69v69H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "white-top_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(68)",
    d: "M0 0h67v69H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "white-top_svg__c"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(134)",
    d: "M0 0h68v69H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "white-top_svg__d"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(603)",
    d: "M0 0h69v69H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "white-top_svg__e"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(671)",
    d: "M0 0h67v69H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "white-top_svg__f"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(737)",
    d: "M0 0h68v69H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "white-top_svg__g"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(268)",
    d: "M0 0h68v69H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "white-top_svg__h"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(335)",
    d: "M0 0h69v69H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "white-top_svg__i"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(403)",
    d: "M0 0h67v69H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "white-top_svg__j"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(469)",
    d: "M0 0h68v69H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "white-top_svg__k"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(201)",
    d: "M0 0h68v69H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "white-top_svg__l"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(536)",
    d: "M0 0h68v69H0z"
  })))));
};

export { SvgWhiteTop as ReactComponent };
export default __webpack_public_path__ + "static/white-top.4ddd6bca.svg";